"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomersModal_1 = __importDefault(require("./CustomersModal"));
exports.default = CustomersModal_1.default;
